import React, { useEffect, useState } from "react";
import SponsoredService from "../../services/sponsored";
import decodeToken from "../../utils/decodeToken";
import SponseredKidCard from "./components/Card";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "../../components/Loader";
import Category from "./components/Category";
import { Form } from "react-bootstrap";
import RangeSlider from "react-bootstrap-range-slider";
import CategoryService from "../../services/categories";
import MobileFooter from "../../components/MobileFooter";
import KidProfileModal from "../kids/components/KidProfileModal";
import KidSponsorModal from "../kids/components/KidSponsorModal";
import KidService from "../../services/kids";
import { useSponsorResumeReopen } from "../../utils/sponsorResume";
// import NewNavBar from "../../components/NewNavBar";

const SponsoredKids = () => {
  const { user_id, super_admin_id, email } = decodeToken();
  const [sponsoredKids, setSponsoredKids] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeIndex, setActiveIndex] = useState(null);
  const [categories, setCategories] = useState([]);
  const [filterSponsoredKidsData, setFilterSponsoredKidsData] = useState([]);
  const [categoryId, setCategoryId] = useState(null);
  const [states, setStates] = useState([]);
  const [stateVal, setStateVal] = useState("");
  const [genderVal, setGenderVal] = useState("");
  const [budgetVal, setBudgetVal] = useState(0);
  const [openFilter, setOpenFilter] = useState(null);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [selectedKidId, setSelectedKidId] = useState(null);
  const [showSponsorModal, setShowSponsorModal] = useState(false);

  const navigate = useNavigate();

  useSponsorResumeReopen(setSelectedKidId, setShowSponsorModal);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    getAllSponsoredKids();
    getAllCategories();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getAllSponsoredKids = async () => {
    try {
      const { data } = super_admin_id
        ? await SponsoredService.fetchSponsorKidsByMentor(null, null, {
            allForSuperAdmin: true,
          })
        : await SponsoredService.fetchSponsorKidsByMentor(user_id, email);

      const sponsorRows = (data.data || []).filter((row) => row.is_active);

      // Process the data to get unique kids (prefer latest active row per kid)
      const uniqueKids = Object.values(
        sponsorRows
          .sort(
            (a, b) =>
              new Date(b.mentored_on_date) - new Date(a.mentored_on_date),
          )
          .reduce((acc, curr) => {
            if (!acc[curr.kid_id]) {
              acc[curr.kid_id] = curr;
            }
            return acc;
          }, {}),
      );

      // Fetch full profiles for each kid and merge
      const kidsWithProfiles = await Promise.all(
        uniqueKids.map(async (kid) => {
          try {
            const profileRes = await KidService.fetchKidById(kid.kid_id);
            const profile = profileRes.data.data[0];
            return { ...kid, ...profile };
          } catch (e) {
            return kid;
          }
        }),
      );

      const filteredKids = kidsWithProfiles.filter(
        (k) => k.is_active && !k.to_be_sponsor,
      );
      const filtered_by_mentored_date = [...filteredKids].sort((a, b) => {
        // return new Date(b.created_at) - new Date(a.created_at);
        return new Date(b.mentored_on_date) - new Date(a.mentored_on_date);
      });

      setSponsoredKids(filtered_by_mentored_date);
      setFilterSponsoredKidsData(filtered_by_mentored_date);

      // Extract unique states
      let statesArr = filteredKids.filter((k) => k.state).map((s) => s.state);
      setStates([...new Set(statesArr)]);

      setLoading(false);
    } catch (err) {
      setSponsoredKids([]);
      setFilterSponsoredKidsData([]);
      setLoading(false);
      console.log(err);
    }
  };

  const getAllCategories = async () => {
    try {
      const { data } = await CategoryService.fetchCategories();
      setCategories(data.data);
    } catch (err) {
      console.log(err);
    }
  };

  const onViewProfile = (id) => {
    setSelectedKidId(id);
    setShowProfileModal(true);
  };

  const closeProfileModal = () => {
    setShowProfileModal(false);
    setSelectedKidId(null);
  };

  const updateKidToBeSponsor = async (kid_id, kid_name) => {
    if (!super_admin_id) return;

    let to_be_sponsor = true;
    let is_sponsored = false;
    try {
      await SponsoredService.updateKidToBeSponsor({
        kid_id,
        to_be_sponsor,
        is_sponsored,
      });
      toast.success(`${kid_name} moved to Sponsor successfully`);
      getAllSponsoredKids();
    } catch (err) {
      const message =
        err.response?.data?.message || "Something went wrong!";
      toast.error(message);
    }
  };

  // Function to handle category selection
  const onCategory = (e, category_id, index) => {
    if (category_id) {
      setActiveIndex(index);
      setFilterSponsoredKidsData(
        sponsoredKids.filter(
          (d) =>
            d.category_id === category_id &&
            (genderVal ? d.gender === genderVal : true) &&
            (stateVal ? d.state === stateVal : true) &&
            (budgetVal > 0 ? parseInt(budgetVal) >= d.total_expenses : true),
        ),
      );
      setCategoryId(category_id);
    } else {
      e.target.classList.add("active");
      setActiveIndex(null);
      setFilterSponsoredKidsData(
        sponsoredKids.filter(
          (d) =>
            (genderVal ? d.gender === genderVal : true) &&
            (stateVal ? d.state === stateVal : true) &&
            (budgetVal > 0 ? parseInt(budgetVal) >= d.total_expenses : true),
        ),
      );
      setCategoryId(null);
    }
  };

  // Function to handle filter changes
  const onChangeFilter = (e) => {
    const { value, name } = e.target;

    if (name === "gender") {
      setGenderVal(value);
      applyFilters(categoryId, value, stateVal, budgetVal);
    } else if (name === "state") {
      setStateVal(value);
      applyFilters(categoryId, genderVal, value, budgetVal);
    } else if (name === "budget") {
      setBudgetVal(value);
      applyFilters(categoryId, genderVal, stateVal, value);
    }
  };

  // Centralized filter function to avoid repetition
  const applyFilters = (category, gender, state, budget) => {
    setFilterSponsoredKidsData(
      sponsoredKids.filter((k) => {
        const matchesCategory = category ? k.category_id === category : true;
        const matchesGender = gender ? k.gender === gender : true;
        const matchesState = state ? k.state === state : true;
        const matchesBudget =
          budget > 0 ? parseInt(budget) >= k.total_expenses : true;

        return (
          matchesCategory && matchesGender && matchesState && matchesBudget
        );
      }),
    );
  };
  const getCategoryCount = (categoryId) => {
    if (!filterSponsoredKidsData || !Array.isArray(filterSponsoredKidsData))
      return 0;

    if (categoryId === null) {
      // Return total count for "All kids" button
      return filterSponsoredKidsData.length;
    }

    // Count kids that belong to this category
    return filterSponsoredKidsData.filter((kid) => {
      // Handle different possible property names for category ID
      const kidCategoryId =
        kid.category_id || kid.categoryId || kid.category?.id;
      return kidCategoryId === categoryId;
    }).length;
  };

  return (
    <>
      {/* <NewNavBar /> */}
      {loading ? (
        <Loader />
      ) : (
        <section className="category-container main-container">
          {/* Full Width Header Banner */}
          <div className="header-banner">
            <img
              src="img/SponsoredChild300x.jpg"
              alt="Sponsored Kids"
              style={{ marginTop: "1rem" }}
            />
          </div>

          {/* Content Container */}
          <div className="container content-container">
            {/* Categories row */}
            <div
              className="row category-container"
              style={{
                marginTop: 0,
                marginBottom: 20,
                padding: windowWidth < 768 ? "0 10px" : "0",
              }}
            >
              <div
                className="col-12"
                style={{
                  position: "relative",
                  padding: windowWidth < 768 ? "0 10px" : "0 30px",
                }}
              >
                <Category
                  activeIndex={activeIndex}
                  kidsData={sponsoredKids}
                  onCategoryHandler={onCategory}
                  categoryData={categories}
                  getCategoryCount={getCategoryCount}
                />
              </div>
            </div>

            {/* Content row */}
            <div className="custom-card-grid" style={{ marginTop: "1rem" }}>
              {filterSponsoredKidsData?.length > 0 ? (
                filterSponsoredKidsData.map((kid) => (
                  <div className="custom-card-col" key={kid.id || kid.kid_id}>
                    <SponseredKidCard
                      user_id={user_id}
                      super_admin_id={super_admin_id}
                      onViewProfile={onViewProfile}
                      updateKidToBeSponsor={
                        super_admin_id ? updateKidToBeSponsor : undefined
                      }
                      data={kid}
                    />
                  </div>
                ))
              ) : (
                <div className="col-12">
                  <h5 className="alert alert-danger text-center">
                    No Sponsored Kid Found
                  </h5>
                </div>
              )}
            </div>
          </div>
        </section>
      )}
      {/* Kid Profile Modal */}
      <KidProfileModal
        isOpen={showProfileModal}
        onClose={closeProfileModal}
        kidId={selectedKidId}
        onSponsorClick={(id) => {
          closeProfileModal();
          setShowSponsorModal(true);
          setSelectedKidId(id);
        }}
        isSponsoredKid={true}
      />
      <KidSponsorModal
        isOpen={showSponsorModal}
        onClose={() => {
          setShowSponsorModal(false);
          setSelectedKidId(null);
        }}
        kidId={selectedKidId}
      />
      <style>{`
        .main-container {
          margin-top: 70px;
        }

        .header-banner {
          width: 100%;
        }

        .header-content {
          display: flex;
          max-width: 1140px;
          margin: 0 auto;
          padding: 0 1rem;
        }

        .header-image {
          width: 400px;
          height: 235px;
          object-fit: cover;
        }

        .header-text-container {
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding-left: 20px;
        }

        .header-title {
          font-size: 3rem;
          font-weight: bolder;
          margin: 0 0 10px 0;
          color: #ffffff;
        }

        .header-subtitle {
          font-size: 1.1rem;
          margin: 0;
          color: #ffffff;
        }

        .content-container {
          background-color: #fff;
          padding-top: 20px;
        }

        .category-container {
          margin-top: 0;
          margin-bottom: 20px;
          overflow: hidden;
        }

        .filter-button {
          margin-bottom: 15px;
        }

        .horizontal-filter-container {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          gap: 15px;
          padding: 15px;
          border-radius: 5px;
          margin-bottom: 20px;
        }

        .filter-label {
          font-weight: 500;
          margin-right: 10px;
        }

        .filter-item {
          margin-right: 15px;
        }

        .dropdown-button {
          border: 1px solid #ddd;
          border-radius: 20px;
          padding: 6px 15px;
          background-color: #fff;
          font-size: 14px;
          font-weight: 500;
        }

        .budget-range {
          width: 100%;
          max-width: 300px;
        }

        /* Kids Grid Styles */
        .custom-card-grid {
          display: flex;
          flex-wrap: wrap;
          margin-left: -12px;
          margin-right: -12px;
        }
        .custom-card-col {
          padding: 12px;
          flex: 0 0 25%;
          max-width: 25%;
          display: flex;
          justify-content: center;
        }
        @media (max-width: 1270px) {
          .custom-card-col {
            flex: 0 0 33.3333%;
            max-width: 33.3333%;
          }
        }
        @media (max-width: 991px) {
          .custom-card-col {
            flex: 0 0 50%;
            max-width: 50%;
          }
        }
        @media (max-width: 768px) {
          .custom-card-col {
            flex: 0 0 100%;
            max-width: 100%;
          }
        }

        /* Media Query for Small Screens */
        @media (max-width: 768px) {
          .main-container {
            margin-top: 50px !important;
          }

          .header-content {
            flex-direction: column;
            align-items: center;
            text-align: center;
            padding: 0 1rem;
          }

          .header-image {
            width: 100%;
            max-width: 300px;
            height: auto;
            margin-bottom: 20px;
            margin-top: 0 !important;
          }

          .header-text-container {
            padding-left: 0;
          }

          .header-title {
            font-size: 2rem;
          }

          .header-subtitle {
            font-size: 1rem;
          }

          /* Mobile Card Layout */
          .custom-card-col {
            flex: 0 0 100%;
            max-width: 100%;
          }
        }

        /* Additional Media Query for Extra Small Screens */
        @media (max-width: 480px) {
          .main-container {
            margin-top: 50px !important;
          }

          .header-banner {
            padding: 20px 0;
          }

          .header-title {
            font-size: 1.8rem;
          }

          .header-subtitle {
            font-size: 0.9rem;
          }

          .content-container {
            padding: 10px 0;
          }

          .custom-card-col {
            padding: 0.5rem 0.75rem;
          }
        }

        /* Category Slider Styles */
        .slick-slider {
          margin: 0 -10px;
        }

        .slick-slide {
          padding: 0 10px;
        }

        .slick-prev,
        .slick-next {
          z-index: 1;
          width: 30px;
          height: 30px;
          background: #fff !important;
          border-radius: 50%;
          box-shadow: 0 2px 4px rgba(0,0,0,0.1);
        }

        .slick-prev {
          left: -15px;
        }

        .slick-next {
          right: -15px;
        }

        .slick-prev:before,
        .slick-next:before {
          color: #299d8e;
        }

        @media (max-width: 768px) {
          .slick-prev,
          .slick-next {
            display: none !important;
          }
        }
      `}</style>
      {/* Add MobileFooter */}
      <MobileFooter />
    </>
  );
};

export default SponsoredKids;
